export default __webpack_public_path__ + "static/media/icon-4.c5da83bb.png";